// export const Authendpoint={
//     loginApi: `/auth/login`,
//     logout: `admin/log-out`,
//     checkPasswordStatus:"Auth/checkPasswordStatus",
//     sendpasswordOtp:"Auth/sendPasswordOtp",
//     setPasswordAndPin:"Auth/setPasswordAndPin",
//     Logout:"Auth/logout",
//     VeriFyPin:"Auth/verifyPin",
//     sendResetPasswordOtp:"Auth/sendOtp",
//     resetPassword:"auth/resetPassword",
//     resetPin:"auth/resetPin",
  
//     getCountryAuthless:"auth/countries",
//     getStateAuthLess:"auth/getStates",
//     getCityAuthLess:"auth/getCities",
//     getMmberTypeAuthLess:"auth/memberTypes"
// }
// export const Globalendpoints={
//     getDashBoard:"/api/v1/admin/dashboard/dashboard-stats",
//     getDashBoardCharts: "/api/v1/admin/dashboard/price-filter",
//     register:"/api/v1/admin/auth/register-vendor",
//     getordersDetails:"/api/v1/admin/order/get-all-orders",
//     getrestroList: "/api/v1/admin/vendor/restaurant-vendors",
//     getallrestroList: "/api/v1/admin/restaurant/fetch-restaurants",
//     restroDisabled: "/api/v1/admin/restaurant/disable-restaurant",
//     vendorDisable: "/api/v1/admin/vendor/disable-vendor",
//     getCategoryList:"/api/v1/admin/category/fetch-category",
//     addCategory: "/api/v1/admin/category/create-category",
//     getVendorsDetails:"/api/v1/admin/vendor/getVendorList",
//     Profile:"Api/V1/Member/profile",
//     changePassword:"Api/V1/Member/changePassword",
//     changePin:"Api/V1/Member/changePin",
//     getwalletBalance:"Api/V1/Member/getWalletBalance",
//     getCountry:"Api/V1/Member/countries",
//     getState:"Api/V1/Member/getStates",
//     getCity:"Api/V1/Member/getCities",
//     getBanks:"Api/V1/Verification/getBanks",
//     addBankAccount:"Api/V1/Verification/addBankAccount",
//     getMemberServices:"Api/V1/Member/memberServices",
//     getWalletReport:"Api/V1/Member/walletReport",
//     checkKycStatus:"Api/V1/DigioKyc/checkKycStatus",
//     getTransactionOtp:"Api/V1/Member/getTransactionOtp",
//     loginApi: `/api/v1/admin/auth/login`,
//     //FUND REQUESTS
//     submitFundRequest:"Api/V1/Member/submitfundRequest",
//     adminBankDetail:"Api/V1/Member/adminBankDetails",
//     // RECHARGE ENDPOINTS
//     operatorAndCircle:"Api/V1/Recharge/opratorAndCircle",
//     rechargePlans:"Api/V1/Recharge/plans",
//     getOperatorAsNumber:"Api/V1/Recharge/operator",
//     recharge:"Api/V1/Recharge/recharge",
//     rechargeStatus:"Api/V1/Recharge/checkRechargeStatus",
    
//     //dth operator
//     operatorAndCircleDTH:"Api/V1/Recharge/getDthOperator",

//     //BBSP API'S
//     bbspsOperator:"Api/V1/Bbps/operators/",
//     bbpsFormParams:"Api/V1/Bbps/formParameters/",
//     fetchBill:"Api/V1/Bbps/fetchBill/",
//     paybill:"Api/V1/Bbps/billPayment/",
    
//     //DMT API'S
//     submitKyc:"Api/V1/Dmt/submitKyc",
//     verifyKycOtp:"Api/V1/Dmt/verifyOtp",
//     getRemitters:"Api/V1/Dmt/getRemitter",
//     AddRemiter:"Api/V1/Dmt/remitterRegisteration",
//     verifyRemitterOtp:"Api/V1/Dmt/verifyRemitterOtp",
//     dmtBanks:"Api/V1/Dmt/getDmtBanks",
//     benificiaryReg:"Api/V1/Dmt/beneficiaryRegistration",
//     verifyBenificiary:"Api/V1/Dmt/verifyBeneficiaryOtp",
//     beneficiaryDelete:"Api/V1/Dmt/beneficiaryDelete",
//     verifyBeneficiaryDelete:"Api/V1/Dmt/verifyBeneficiaryDeleteOtp",
//     fundTransfer:"Api/V1/Dmt/fundTransfer",
//     //PAYOUT API'S
//     getPayoutBanks:"Api/V1/Payout/getPayoutBanks",
//     payoutVerification:"Api/V1/AccountVerification/verifyBankAccount",
//     payAmount:"Api/V1/Payout/payout",
//     generateQr:"Api/V1/Upi/generateUpi",
//     checkUpiPaymentstatus:"Api/V1/Upi/checkUpiPaymentStatus",
//     UpiDmt:"Api/V1/UpiDmt/upiDmt",
//     // EXPRESSPAYOUT
//     getXpressBeneficiary:"Api/V1/XpressPayout/getBeneficiaries",
//     XpressPAyout:"Api/V1/XpressPayout/xpressPayout",
//     OtpForExpress:"Api/V1/Member/getTransactionOtp",
//     //UTI AUTOLOGIN
//     utliLogin:"Api/V1/Uti/autoLogin",

//     //NSDL SERVICE
//     nsdlrequest:"Api/V1/Nsdl/",
//     checkPanStatus:"Api/V1/Nsdl/checkPanStatus",
    
//     // KYC REQUEST
//     DigioKyc:"Api/V1/DigioKyc/generateDigioRequest",
    
//     //AEPS ONBOARD
    
//     getMasters:"Api/V1/AepsCredo/master",
//     getMaster:"Api/V1/AepsCredo/masters",
//     merchantOnboard:"Api/V1/AepsCredo/merchantOnboard",
//     terminalOnboard: "Api/V1/AepsCredo/getTerminals",
//     sendOtp:"Api/V1/AepsIcici/sendOtp",
//     validateOtp:"Api/V1/AepsIcici/validateOtp",
//     resendOtp:"Api/V1/AepsIcici/resendOtp",
//     biometric:"Api/V1/AepsIcici/biometric",
//     twoFactorauth:"Api/V1/AepsIcici/twoFactorAuth",
//     cashwithdrawl:"Api/V1/AepsIcici/cashWithdrawl",
//     balanceEnquiry:"Api/V1/AepsIcici/balanceEnquiry",
//     miniStatement:"Api/V1/AepsIcici/miniStatement",
//     aadharPay:"Api/V1/AepsIcici/aadharPay",
    
//     // AEPS YES BANK
//     memberUploadDoc:"Api/V1/AepsYesbank/uploadDocument",
//     memberkyc:"Api/V1/AepsYesbank/memberKyc",
//     getKycData:"Api/V1/AepsYesbank/getKycData",
//     getYesMasters:"Api/V1/AepsYesbank/masters",
//     yesMerchantOnboard:"Api/V1/AepsYesbank/merchantOnboard",
//     yesValidateOtp:"Api/V1/AepsYesbank/validateOtp",
//     yesGetAadharWadh:"Api/V1/AepsYesbank/getAadhaarWadh",
//     yesBiometric:"Api/V1/AepsYesbank/biometricKyc",
//     yesTwoFactorAuth:"Api/V1/AepsYesbank/twoFactorAuth",
//     yesCahwithdrawalTwoFa:"Api/V1/AepsYesbank/twoFactorAuthCashWithdrawal",
//     yesCashwithdrawl:"Api/V1/AepsYesbank/cashWithdrawal",
//     yesBalanceEnquiry:"Api/V1/AepsYesbank/balanceEnquiry",
//     yesMiniStatement:"Api/V1/AepsYesbank/miniStatement",
//     // MEMBERS
//     addmember:"Api/V1/Member/memberSubmit",
//     getmemberType:"Api/V1/Member/memberTypes",
//     getPackages:"Api/V1/Member/getPackages",
//     memberList:"Api/V1/Member/members",
    
//     //REPORTS
//     aadharpayReport:"Api/V1/AepsIcici/aadharPayReport",
//     miniSattementReport:"Api/V1/AepsIcici/miniStatementReport",
//     cashwithdrawlReport:"Api/V1/AepsIcici/cashWithdrawlReport",
//     utiReport:"Api/V1/uti/utiReport",
//     payoutReport:"Api/V1/Payout/payoutReport",
//     dmtReport:"Api/V1/Dmt/dmtReport",
//     bbpsreport:"Api/V1/Bbps/bbpsReport",
//     rechargeReport:"Api/V1/Recharge/rechargeReport",
//     fundRequestReport:"Api/V1/Member/fundRequestReport",
//     upiReport:"Api/V1/Upi/upiReport",
//     xpressPayoutReport:"Api/V1/XpressPayout/xpressPAyoutReport",
//     balanceEnquireyReport:"Api/V1/AepsIcici/balanceEnquiryReport",
//     nsdlReport:"Api/V1/Nsdl/nsdlReport",
//     yesBankReport:"Api/V1/AepsYesbank/aepsReport",
//     upiDmtReport:"Api/V1/UpiDmt/upiDmtReport",
//     MAtmReport:"Api/V1/Matm/matmReport",
//     balanceTransferReport:"Api/V1/Member/balanceTransferReport",
//     //BANK VERIFICATION
//     verifyBank:"Api/V1/Verification/verifyBankDetails",

//     balanceTransfer:"Api/V1/Member/balanceTransfer",


//     downLoadCertificate:"Api/V1/Member/certificateDownload"
    
// }





// src/ApiServices/global.js

export const Authendpoint = {
    loginApi: `/api/v1/admin/auth/login`,
    logout: `/api/v1/admin/auth/logout`,
    checkPasswordStatus: `/api/v1/admin/auth/check-password-status`,
    sendpasswordOtp: `/api/v1/admin/auth/send-password-otp`,
    setPasswordAndPin: `/api/v1/admin/auth/set-password-and-pin`,
    Logout: `/api/v1/admin/auth/logout`,
    VeriFyPin: `/api/v1/admin/auth/verify-pin`,
    sendResetPasswordOtp: `/api/v1/admin/auth/send-reset-password-otp`,
    resetPassword: `/api/v1/admin/auth/reset-password`,
    resetPin: `/api/v1/admin/auth/reset-pin`,
    getCountryAuthless: `/api/v1/admin/auth/countries`,
    getStateAuthLess: `/api/v1/admin/auth/states`,
    getCityAuthLess: `/api/v1/admin/auth/cities`,
    getMmberTypeAuthLess: `/api/v1/admin/auth/member-types`
};

export const Globalendpoints = {
    // ============================================
    // AUTH & DASHBOARD
    // ============================================
    loginApi: `/api/v1/admin/auth/login`,
    getDashBoard: `/api/v1/admin/dashboard/dashboard-stats`,
    getDashBoardVendorPlans: `/api/v1/admin/dashboard/vendor-plans`,
    register: `/api/v1/admin/auth/register-vendor`,

    // ============================================
    // PROFILE
    // ============================================
    getProfile: `/api/v1/admin/auth/profile`,
    updateProfile: `/api/v1/admin/auth/update-profile`,
    Profile: `/api/v1/admin/member/profile`,
    changePassword: `/api/v1/admin/member/change-password`,
    changePin: `/api/v1/admin/member/change-pin`,
    getwalletBalance: `/api/v1/admin/member/wallet-balance`,

    // ============================================
    // CATEGORY
    // ============================================
    getCategoryList: `/api/v1/admin/category/fetch-category`,
    addCategory: `/api/v1/admin/category/create-category`,

    // ============================================
    // VENDOR
    // ============================================
    getVendorsDetails: `/api/v1/admin/vendor/getVendorList`,
    vendorDisable: `/api/v1/admin/vendor/disable-vendor`,
    getrestroList: `/api/v1/admin/vendor/restaurant-vendors`,

    // ============================================
    // RESTAURANT
    // ============================================
    getallrestroList: `/api/v1/admin/restaurant/fetch-restaurants`,
    addRestro: `/api/v1/admin/restaurant/add-restaurant`,
    restroDisabled: `/api/v1/admin/restaurant/disable-restaurant`,
    getrestroPermissionsList: `/api/v1/admin/restaurant/permissions`,

    createRestaurant: `/api/v1/admin/auth/restaurant`,
    updateRestaurant: `/api/v1/admin/auth/restaurant`,

    // ============================================
    // ORDERS
    // ============================================
    getordersDetails: `/api/v1/admin/order/get-all-orders`,

    // ============================================
    // BRAND
    // ============================================
    brandlist: `/api/v1/admin/brand/list`,
    addbrand: `/api/v1/admin/brand/add`,
    editBrand: `/api/v1/admin/brand/edit`,

    // ============================================
    // TRANSACTIONS
    // ============================================
    gettransactionList: `/api/v1/admin/transaction/list`,
    settledAmount: `/api/v1/admin/transaction/settled`,
    getWalletReport: `/api/v1/admin/member/wallet-report`,

    // ============================================
    // ROLES & PERMISSIONS
    // ============================================
    updateRole: `/api/v1/admin/role/update`,

    // ============================================
    // LOCATION
    // ============================================
    getCountry: `/api/v1/admin/location/countries`,
    getState: `/api/v1/admin/location/states`,
    getCity: `/api/v1/admin/location/cities`,

    // ============================================
    // BANKS
    // ============================================
    getBanks: `/api/v1/admin/bank/list`,
    addBankAccount: `/api/v1/admin/bank/add`,
    verifyBank: `/api/v1/admin/bank/verify`,

    // ============================================
    // MEMBERS
    // ============================================
    getMemberServices: `/api/v1/admin/member/services`,
    getmemberType: `/api/v1/admin/member/types`,
    addmember: `/api/v1/admin/member/add`,
    getPackages: `/api/v1/admin/member/packages`,
    memberList: `/api/v1/admin/member/list`,
    checkKycStatus: `/api/v1/admin/member/kyc-status`,
    getTransactionOtp: `/api/v1/admin/member/transaction-otp`,
    balanceTransfer: `/api/v1/admin/member/balance-transfer`,
    balanceTransferReport: `/api/v1/admin/member/balance-transfer-report`,
    downLoadCertificate: `/api/v1/admin/member/certificate-download`,

    // ============================================
    // FUND REQUESTS
    // ============================================
    submitFundRequest: `/api/v1/admin/fund/request`,
    adminBankDetail: `/api/v1/admin/fund/admin-bank-details`,
    fundRequestReport: `/api/v1/admin/fund/request-report`,

    // ============================================
    // RECHARGE
    // ============================================
    operatorAndCircle: `/api/v1/recharge/operator-circle`,
    rechargePlans: `/api/v1/recharge/plans`,
    getOperatorAsNumber: `/api/v1/recharge/operator`,
    recharge: `/api/v1/recharge/recharge`,
    rechargeStatus: `/api/v1/recharge/check-status`,
    rechargeReport: `/api/v1/recharge/report`,

    // ============================================
    // DTH
    // ============================================
    operatorAndCircleDTH: `/api/v1/recharge/dth-operator`,

    // ============================================
    // BBPS
    // ============================================
    bbspsOperator: `/api/v1/bbps/operators`,
    bbpsFormParams: `/api/v1/bbps/form-parameters`,
    fetchBill: `/api/v1/bbps/fetch-bill`,
    paybill: `/api/v1/bbps/pay-bill`,
    bbpsreport: `/api/v1/bbps/report`,

    // ============================================
    // DMT
    // ============================================
    submitKyc: `/api/v1/dmt/submit-kyc`,
    verifyKycOtp: `/api/v1/dmt/verify-kyc-otp`,
    getRemitters: `/api/v1/dmt/get-remitter`,
    AddRemiter: `/api/v1/dmt/remitter-registration`,
    verifyRemitterOtp: `/api/v1/dmt/verify-remitter-otp`,
    dmtBanks: `/api/v1/dmt/get-banks`,
    benificiaryReg: `/api/v1/dmt/beneficiary-registration`,
    verifyBenificiary: `/api/v1/dmt/verify-beneficiary-otp`,
    beneficiaryDelete: `/api/v1/dmt/beneficiary-delete`,
    verifyBeneficiaryDelete: `/api/v1/dmt/verify-beneficiary-delete-otp`,
    fundTransfer: `/api/v1/dmt/fund-transfer`,
    dmtReport: `/api/v1/dmt/report`,

    // ============================================
    // PAYOUT
    // ============================================
    getPayoutBanks: `/api/v1/payout/get-banks`,
    payoutVerification: `/api/v1/payout/verify-bank`,
    payAmount: `/api/v1/payout/pay`,
    payoutReport: `/api/v1/payout/report`,

    // ============================================
    // UPI
    // ============================================
    generateQr: `/api/v1/upi/generate-qr`,
    checkUpiPaymentstatus: `/api/v1/upi/check-status`,
    upiReport: `/api/v1/upi/report`,
    upiDmtReport: `/api/v1/upi-dmt/report`,

    // ============================================
    // UPI DMT
    // ============================================
    UpiDmt: `/api/v1/upi-dmt/upi-dmt`,

    // ============================================
    // EXPRESS PAYOUT
    // ============================================
    getXpressBeneficiary: `/api/v1/xpress-payout/get-beneficiaries`,
    XpressPAyout: `/api/v1/xpress-payout/payout`,
    OtpForExpress: `/api/v1/member/get-transaction-otp`,
    xpressPayoutReport: `/api/v1/xpress-payout/report`,

    // ============================================
    // UTI
    // ============================================
    utliLogin: `/api/v1/uti/auto-login`,
    utiReport: `/api/v1/uti/report`,

    // ============================================
    // NSDL
    // ============================================
    nsdlrequest: `/api/v1/nsdl/request`,
    checkPanStatus: `/api/v1/nsdl/check-pan-status`,
    nsdlReport: `/api/v1/nsdl/report`,

    // ============================================
    // KYC
    // ============================================
    DigioKyc: `/api/v1/kyc/digio-request`,

    // ============================================
    // AEPS - ICICI
    // ============================================
    getMasters: `/api/v1/aeps/icici/masters`,
    getMaster: `/api/v1/aeps/icici/master`,
    merchantOnboard: `/api/v1/aeps/icici/merchant-onboard`,
    terminalOnboard: `/api/v1/aeps/icici/get-terminals`,
    sendOtp: `/api/v1/aeps/icici/send-otp`,
    validateOtp: `/api/v1/aeps/icici/validate-otp`,
    resendOtp: `/api/v1/aeps/icici/resend-otp`,
    biometric: `/api/v1/aeps/icici/biometric`,
    twoFactorauth: `/api/v1/aeps/icici/two-factor-auth`,
    cashwithdrawl: `/api/v1/aeps/icici/cash-withdrawl`,
    balanceEnquiry: `/api/v1/aeps/icici/balance-enquiry`,
    miniStatement: `/api/v1/aeps/icici/mini-statement`,
    aadharPay: `/api/v1/aeps/icici/aadhar-pay`,
    aadharpayReport: `/api/v1/aeps/icici/aadhar-pay-report`,
    miniSattementReport: `/api/v1/aeps/icici/mini-statement-report`,
    cashwithdrawlReport: `/api/v1/aeps/icici/cash-withdrawl-report`,
    balanceEnquireyReport: `/api/v1/aeps/icici/balance-enquiry-report`,

    // ============================================
    // AEPS - YES BANK
    // ============================================
    getYesMasters: `/api/v1/aeps/yesbank/masters`,
    memberUploadDoc: `/api/v1/aeps/yesbank/upload-document`,
    memberkyc: `/api/v1/aeps/yesbank/member-kyc`,
    getKycData: `/api/v1/aeps/yesbank/get-kyc-data`,
    yesMerchantOnboard: `/api/v1/aeps/yesbank/merchant-onboard`,
    yesValidateOtp: `/api/v1/aeps/yesbank/validate-otp`,
    yesGetAadharWadh: `/api/v1/aeps/yesbank/get-aadhaar-wadh`,
    yesBiometric: `/api/v1/aeps/yesbank/biometric-kyc`,
    yesTwoFactorAuth: `/api/v1/aeps/yesbank/two-factor-auth`,
    yesCahwithdrawalTwoFa: `/api/v1/aeps/yesbank/two-factor-auth-cash-withdrawal`,
    yesCashwithdrawl: `/api/v1/aeps/yesbank/cash-withdrawal`,
    yesBalanceEnquiry: `/api/v1/aeps/yesbank/balance-enquiry`,
    yesMiniStatement: `/api/v1/aeps/yesbank/mini-statement`,
    yesBankReport: `/api/v1/aeps/yesbank/report`,

    // ============================================
    // MATM
    // ============================================
    MAtmReport: `/api/v1/matm/report`,
};